var path = '/glow/component/glow-module/module-image-promo/tpl/module-image-promo.html';
var html = "<div class=glow-image-promo role=region aria-label={{$ctrl.name}}> <div class=\"glow-image-promo-wrapper text-center\" ng-style=$ctrl.styles.wrapper ng-class=$ctrl.classes.wrapper> <a ng-if=$ctrl.linkUrl ng-href={{$ctrl.linkUrl}} target={{$ctrl.windowTarget}} ng-click=$ctrl.trackImagePromoClick($ctrl.linkUrl)> <img class=promo-image ng-src={{image}} alt={{$ctrl.imageAltText}} /> </a> <img ng-if=!$ctrl.linkUrl class=promo-image ng-src={{image}} alt={{$ctrl.imageAltText}} /> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/glow/component/glow-module/module-image-promo/tpl/module-image-promo.html
// module id = 1750
// module chunks = 1